import * as React from 'react';
import { SVGProps } from 'react';

const IconRevertSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.11 4.753 2.75 2l-1 7h7L6.413 6.274a8 8 0 1 1-1.723 8.98l-1.825.813A10 10 0 1 0 5.11 4.753z" />
  </svg>
);
export default IconRevertSizeM;
